<template>
  <div class="dispose-hours">
    <template>
      <div class="dispose-hours-menu">
        <a-menu v-model="current" mode="horizontal">
          <a-menu-item
            class="dispose-hours-menu-item"
            key="options"
            @click="switchTab('options')"
          >选项维度</a-menu-item>
          <a-menu-item key="teams" @click="switchTab('teams')">团队维度</a-menu-item>
        </a-menu>
      </div>
    </template>
    <div class="dispose-hours-wrapper" v-if="currentTab == 'options'">
      <div class="loading-icon" v-if="showLoading">
        <a-spin size="large" />
      </div>
      <div class="dispose-hours-left" v-if="!showLoading">
        <team-tree
          :list="optionTreeList"
          :loading="showLoading"
          @getLoadKey="getLoadKey"
          @reload="reload"
        ></team-tree>
      </div>
      <div class="dispose-hours-right" v-if="!showLoading">
        <div class="top-btn">
          <div class="top-btn-left">
            <a-button
              type="primary"
              @click="showModal('add', 'option')"
              :disabled="level != 2"
            >
              <a-icon type="plus" />添加选项
            </a-button>
          </div>
          <div class="top-btn-right">
            <a-button class="btn-left" @click="confirmStart">启用</a-button>
            <a-button @click="confirmStop">停用</a-button>
          </div>
        </div>
        <a-table
          class="dispose-data-table"
          v-if="currentTab === 'options'"
          :rowKey="record => record.option_code"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="false"
          :loading="loading"
          @change="handleTableChange"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        >
          <template slot-scope="text,record,index" slot="business_line">
            <div class="operation">
              <span v-html="getBizName(record.business_line) || ''"></span>
            </div>
          </template>
          <template slot-scope="text,record,index" slot="assign_confirm">
            <div class="operation">
              <span v-if="record.assign_confirm == 1">是</span>
              <span v-else>否</span>
            </div>
          </template>
          <template slot-scope="text,record,index" slot="status">
            <div class="operation">
              <span v-if="record.status == 1">使用中</span>
              <span v-else>已停用</span>
            </div>
          </template>
          <template slot-scope="text,record,index" slot="operation">
            <div class="operation">
              <span @click="editOption(record)">编辑</span>
              <span @click="setTeam(record)">使用团队</span>
              <span>
                <a-popconfirm
                  placement="topRight"
                  okText="确定"
                  cancelText="取消"
                  @confirm="confirm(record.option_code, record.status)"
                >
                  <template slot="title">你确定{{record.status == 1? '停用':'启用'}}此选项吗？</template>
                  <span>{{record.status == 1? '停用':'启用'}}</span>
                </a-popconfirm>
              </span>
            </div>
          </template>
        </a-table>
      </div>
    </div>
    <div class="dispose-hours-wrapper" v-if="currentTab == 'teams'">
      <div class="loading-icon" v-if="showLoading">
        <a-spin size="large" />
      </div>
      <div class="dispose-hours-left" v-if="!showLoading">
        <team-tree :list="teamTreeList" :loading="showLoading" @getLoadKey="getLoadKey"></team-tree>
      </div>
      <div class="dispose-hours-right" v-if="!showLoading">
        <div class="top-btn">
          <div class="top-btn-left">
            <a-button type="primary" @click="visibleShowTeam = true" :disabled="code == undefined">
              <a-icon type="plus" />配置选项
            </a-button>
          </div>
          <div class="top-btn-right">
            <a-button class="btn-left" @click="confirmDelate">批量删除</a-button>
            <!-- <a-button @click="confirmStop">停用</a-button> -->
          </div>
        </div>
        <a-table
          class="dispose-data-table"
          v-if="currentTab === 'teams'"
          :rowKey="record => record.id"
          :columns="columns2"
          :dataSource="dataSource2"
          :pagination="false"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        >
          <template slot-scope="text,record,index" slot="operation">
            <div class="operation">
              <span>
                <a-popconfirm
                  placement="topRight"
                  okText="确定"
                  cancelText="取消"
                  @confirm="confirm2(record.id)"
                >
                  <template slot="title">你确定删除此选项吗？</template>
                  <span>删除</span>
                </a-popconfirm>
              </span>
            </div>
          </template>
        </a-table>
      </div>
    </div>
    <!-- 添加&编辑 -->
    <form-modal2
      v-if="visible"
      :formModel="formModel"
      :params="params"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @on-cancel="handleCancel"
      @on-save="handleOk"
      @on-radio-change="onRadioChange"
    ></form-modal2>
    <!-- 使用团队 -->
    <a-modal
      title="使用团队"
      v-model="visibleTeam"
      :footer="null"
      @ok="visibleTeam = false"
      okText="确认"
      cancelText="取消"
    >
      <ul v-if="recordData && recordData.team_list">
        <li v-for="(r,index) in  recordData.team_list" :key="index">{{r.team_name}}</li>
      </ul>
    </a-modal>
    <!-- 团队添加选项 -->
    <a-modal
      title="团队添加选项"
      v-model="visibleShowTeam"
      @ok="addTeamSheetFn"
      okText="添加"
      cancelText="取消"
    >
      <option-tree 
      v-if="visibleShowTeam" 
      :list="treeData" 
      :selectedKeys="selectedKeys"
      @on-checked="getCheckedKey">
      </option-tree>
    </a-modal>
  </div>
</template>
<script>
import { disposeFunc } from "@/services/DataManageService.js";
import PriceAdminService from "@/services/PriceAdminService.js";
let teamOptionList = [];

export default {
  data() {
    return {
      breadcrumb: [
        {
          label: "数据管理",
          path: ""
        },
        {
          label: "工时选项配置",
          path: ""
        }
      ],
      current: ["options"],
      currentTab: "options",
      columns2: [
        {
          title: "财务科目",
          dataIndex: "cost_name",
          key: "cost_name",
          width: 200
        },
        {
          title: "费用分类",
          dataIndex: "finance_name",
          key: "finance_name",
          width: 180
        },
        {
          title: "工时选项",
          dataIndex: "option_name",
          key: "option_name",
          width: 220
        },
        {
          title: "操作",
          dataIndex: "operation",
          key: "operation",
          width: 200,
          scopedSlots: { customRender: "operation" }
        }
      ],
      dataSource: [],
      dataSource2: [],
      selectedRowKeys: [],
      selectedRowCode: [], // 勾选的选项code
      selectedRowId: [], // 勾选的团队id
      filteredInfo: null,
      sortedInfo: null,
      loading: false,
      totalNum: 10,
      formType: 1,
      params: {},
      visible: false,
      visibleTeam: false,
      visibleShowTeam: false,
      confirmLoading: false,
      optionTreeList: [], // 选项树
      teamTreeList: [], // 团队树
      level: 0, // 默认选中的层级
      bizLineList: [], //成本中心
      lineOfBusiness: [], //业务线
      showLoading: false,
      code: "", // 当前选项的code
      // 添加 && 编辑
      formModel: {
        title: "添加选项",
        cancelText: "取消",
        okText: "确定",
        width: 650,
        formItemLayout: {
          labelCol: {
            sm: { span: 6 }
          },
          wrapperCol: {
            sm: { span: 16 }
          }
        },
        elements: [
          {
            type: "input",
            label: "选项名称",
            key: "option_name",
            required: true,
            show: true,
            placeholder: "请输入"
          },
          {
            type: "select",
            label: "成本中心",
            key: "business_line",
            width: 400,
            required: true,
            show: true,
            placeholder: "请输入",
            options: []
          },
          {
            type: "select",
            label: "业务线",
            key: "line_of_business",
            width: 400,
            required: true,
            show: true,
            placeholder: "请输入",
            options: []
          },
          {
            type: "radio",
            label: "是否审核",
            key: "assign_confirm",
            required: true,
            show: true,
            options: [
              {
                label: "是",
                value: 1
              },
              {
                label: "否",
                value: 0
              }
            ]
          },
          {
            type: "select-multiple",
            label: "一级审核",
            key: "confirm_uid_list",
            width: 288,
            required: true,
            show: false,
            placeholder: "",
            options: []
          },
          {
            type: "select",
            label: "终审",
            key: "last_confirm_uid",
            width: 288,
            required: true,
            show: false,
            placeholder: "",
            options: []
          },
          {
            type: "tree-select",
            label: "使用团队",
            key: "team_list",
            width: 288,
            required: true,
            show: true,
            placeholder: "请选择团队",
            options: []
          },
          {
            type: "radio",
            label: "是否启用",
            key: "status",
            required: true,
            show: true,
            options: [
              {
                label: "是",
                value: 1
              },
              {
                label: "否",
                value: 0
              }
            ]
          }
        ]
      },

      operation: "add", // 操作类型
      recordData: {},
      selectedKeys: [],
      treeData: []
    };
  },
  computed: {
    getBizName() {
      return function(id) {
        let name = "";
        this.bizLineList.map(item => {
          if (item.option_id == id) {
            name = item.option_name;
          }
        });
        return name;
      };
    },
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const columns = [
        {
          title: "工时选项",
          dataIndex: "option_name",
          key: "option_name",
          width: 180
        },
        {
          title: "审核",
          dataIndex: "assign_confirm",
          key: "assign_confirm",
          width: 100,
          scopedSlots: { customRender: "assign_confirm" }
        },
        {
          title: "成本中心",
          dataIndex: "business_line_desc",
          key: "business_line_desc",
          width: 190,
          scopedSlots: { customRender: "business_line_desc" }
        },
        {
          title: "财务科目",
          dataIndex: "finance_name",
          key: "finance_name",
          width: 150
        },
        {
          title: "费用分类",
          dataIndex: "cost_name",
          key: "cost_name",
          width: 120
        },
        {
          title: "使用状态",
          dataIndex: "status",
          key: "status",
          width: 120,
          scopedSlots: { customRender: "status" },
          filters: [
            { text: "使用中", value: "1" },
            { text: "已停用", value: "0" }
          ],
          filteredValue: filteredInfo.status || null,
          onFilter: (value, record) => record.status == value
        },
        {
          title: "操作",
          dataIndex: "operation",
          key: "operation",
          width: 250,
          scopedSlots: { customRender: "operation" }
        }
      ];
      return columns;
    }
  },
  mounted() {
    this.showLoading = true;
    this.getOptionsTreeBlock(); // 获取选项树
    this.getBizLineList(); // 获取成本中心
    this.getUserList(); // 获取成本中心
    this.getTeamTree(); // 获取团队树
    this.getTimesheetList("all");
    // this.getTimesheetTreeList();
  },
  methods: {
    switchTab(e) {
      this.currentTab = e;
      this.showLoading = true;
      this.code = undefined;
      this.operation = "add";
      this.dataSource = [];
      this.dataSource2 = [];
      this.selectedKeys = [];
      this.selectedRowKeys = [];
      this.selectedRowCode = [];
      this.selectedRowId = [];
      setTimeout(() => {
        this.showLoading = false;
      }, 2000);
      if (e == "options") {
        this.getTimesheetList("all");
      } else {
        // this.getTeamOptionList(0);
      }
    },

    showModal(operation, type) {
      this.visible = true;
      this.operation = operation;
      this.type = type;
    },

    onRadioChange(e) {
      if (this.currentTab === "options" && e) {
        this.formModel.elements[4].show = true;
        this.formModel.elements[5].show = true;
      } else if (this.currentTab === "options" && !e) {
        this.formModel.elements[4].show = false;
        this.formModel.elements[5].show = false;
      }
    },

    // 获取工时选项列表
    getTimesheetList(option_code) {
      const params = {
        option_code: option_code || "all"
      };
      this.loading = true;
      disposeFunc.getTimesheetList(params).then(res => {
        if (res.status === "success") {
          this.loading = false;
          this.showLoading = false;
          this.total = res.data.list;
          this.dataSource = res.data.list;
        } else if (res.status === "failed" && res.message) {
          this.$Message.error(res.message);
        }
      });
    },

    // 获取工时选项树 - 用于团队配置选项
    getTimesheetTreeList(team_id = "", template = "") {
      const params = {
        team_id: team_id,
        template: template
      };
      this.loading = true;
      disposeFunc.getTimesheetTreeList(params).then(res => {
        if (res.status === "success") {
          this.loading = false;
          this.showLoading = false;
          this.treeData = res.data;
          this.setOptionTreeData(this.treeData);
        } else if (res.status === "failed" && res.message) {
          this.$Message.error(res.message);
        }
      });
    },

    // 复选框
    onSelectChange(selectedRowKeys, selectedRows) {
      // console.log(selectedRows);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRowCode = selectedRows.map(item => {
        return item.option_code;
      });
      this.selectedRowId = selectedRows.map(item => {
        return item.id;
      });
    },

    // 单个启用
    confirm(id, status) {
      let st = 0;
      if (status == 0) {
        st = 1;
      }
      const params = { option_List: [id], status: st };
      disposeFunc.updateTimesheets(params).then(res => {
        if (res.status === "success") {
          this.$Message.success(`已${st == 1 ? "启用" : "停用"}该工时选项`);
        } else {
          this.$Message.error(res.message);
        }
        this.getTimesheetList(this.code);
      });
    },

    // 批量启用
    confirmStart() {
      this.$Confirm({
        width: 480,
        title: `确定批量启用工时选项吗？`,
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          if (!this.selectedRowCode || !this.selectedRowCode.length) {
            this.$Message.info("选项不能为空");
            return;
          }
          const params = { option_List: this.selectedRowCode, status: 1 };
          disposeFunc.updateTimesheets(params).then(res => {
            if (res.status === "success") {
              this.$Message.success(`已批量启用工时选项`);
            } else {
              this.$Message.error(res.message);
            }
            this.getTimesheetList(this.code);
          });
        }
      });
    },

    // 批量停用工时选项
    confirmStop() {
      this.$Confirm({
        width: 480,
        title: "确定批量停用工时选项吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          if (!this.selectedRowCode || !this.selectedRowCode.length) {
            this.$Message.info("选项不能为空");
            return;
          }
          const params = { option_List: this.selectedRowCode, status: 0 };
          disposeFunc.updateTimesheets(params).then(res => {
            if (res.status === "success") {
              this.$Message.success(`已批量停用工时选项`);
            } else {
              this.$Message.error(res.message);
            }
            this.getTimesheetList(this.code);
          });
        }
      });
    },

    // 单个删除
    confirm2(id) {
      const params = { id_list: [id] };
      disposeFunc.delTeamSheet(params).then(res => {
        if (res.status === "success") {
          this.$Message.success(`已删除当前选项`);
        } else {
          this.$Message.error(res.message);
        }
        this.getTeamOptionList(this.code || 0);
        this.selectedRowId = [];
      });
    },

    // 批量删除
    confirmDelate() {
      this.$Confirm({
        width: 480,
        title: "确定批量删除团队已配置的选项吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          if (!this.selectedRowId || !this.selectedRowId.length) {
            this.$Message.info("选项不能为空");
            return;
          }
          const params = { id_list: this.selectedRowId };
          disposeFunc.delTeamSheet(params).then(res => {
            if (res.status === "success") {
              this.$Message.success(`已批量删除团队选项`);
            } else {
              this.$Message.error(res.message);
            }
            this.getTeamOptionList(this.code || 0);
            this.selectedRowId = [];
          });
        }
      });
    },

    // 取消模态框
    handleCancel() {
      this.visible = false;
      this.visibleTeam = false;
      this.params = {};
    },

    // 添加选项确认按钮
    /**
     * 模态框确认按钮
     * currentTab 当前tab, 选项维度或者团队维度
     * operation 操作类型, 添加,更新
     * evenName 事件类型
     */
    handleOk(e) {
      let params = e;
      this.visible = false;
      this.visibleTeam = false;
      if (this.operation == "add") {
        params.parent_code = this.code;
        this.addTeamSheetOptionFn(params);
      } else {
        params.option_code = this.recordData.option_code;
        if (!e.option_name) {
          params.option_name = this.recordData.option_name;
          params.status = this.recordData.status;
          params.assign_confirm = this.recordData.assign_confirm;
          params.business_line = this.recordData.business_line;
        }
        this.modifyTeamSheetOptionFn(params);
      }
    },

    // 选项添加选项
    addTeamSheetOptionFn(params) {
      disposeFunc
        .addTeamSheetOption(params)
        .then(res => {
          if (res.status == "success") {
            this.params = {};
            this.$Message.success(`添加成功!`);
            this.getTimesheetList(this.code);
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(err => {
          this.$Message.error(err.message);
        });
    },

    // 编辑选项维度
    modifyTeamSheetOptionFn(params) {
      disposeFunc
        .modifyTeamSheetOption(params)
        .then(res => {
          if (res.status == "success") {
            this.params = {};
            this.$Message.success(`更新成功!`);
            this.getTimesheetList(this.code);
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(err => {
          this.$Message.error(err.message);
        });
    },

    // 团队添加选项
    addTeamSheetFn() {
      let params = {};
      params.team_id = this.code || 0;
      params.option_List = this.selectedKeys;
      disposeFunc
        .addTeamSheet(params)
        .then(res => {
          if (res.status == "success") {
            this.params = {};
            this.$Message.success(`添加成功!`);
            this.visibleShowTeam = false;
            this.selectedKeys = [];
            this.getTeamOptionList(this.code || 0);
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(err => {
          this.$Message.error(err.message);
        });
    },

    // 获取一二级目录
    getOptionsTreeBlock() {
      disposeFunc
        .getTimesheetTreeListBlock()
        .then(res => {
          if (res.status == "success") {
            this.optionTreeList = res.data.class_option;
            this.setOptionTreeData(this.optionTreeList, "", true);
            setTimeout(() => {
              this.showLoading = false;
            }, 1000);
          }
        })
        .catch(err => {});
    },

    // 递归处理选项树数据
    // 第三个参数用于判断处理团队维度-团队添加选项的数据
    setOptionTreeData(data, status, dis = false) {
      let nodeItem;
      for (let i = 0; i < data.length; i++) {
        let node = data[i];
        node.expand = true;
        node.scopedSlots = { title: "custom" };
        node.title = node.option_name;
        node.key = node.option_code;
        node.parent_status = status;
        if (node.status == 0) {
          node.disabled = true;
        }
        if (node.children) {
          if (!node.children.length) {
          } else if (this.setOptionTreeData(node.children, node.status)) {
            nodeItem = this.setOptionTreeData(node.children, node.status);
          }
        }
      }
      return nodeItem;
    },

    // 获取团队树
    getTeamTree() {
      disposeFunc.getTeamTreeList({ customized: 0 }).then(res => {
        if (res.status == "success") {
          this.teamTreeList = res.data;
          this.setTreeData(this.teamTreeList);
          // let _teamData = _.cloneDeep(res.data);
          // this.setTreeValueData(_teamData);
          // setTimeout(() => {
          //   const config = _.cloneDeep(this.formModel); //添加&编辑
          //   config.elements[6].options = _teamData;
          //   this.formModel = config;
          // }, 2000);
        }
      });
      disposeFunc.getTeamTreeList({ customized: 1 }).then(res => {
        if (res.status == "success") {
          // this.teamTreeList = res.data;
          // this.setTreeData(this.teamTreeList);
          let _teamData = _.cloneDeep(res.data);
          this.setTreeValueData(_teamData);
          setTimeout(() => {
            const config = _.cloneDeep(this.formModel); //添加&编辑
            config.elements[6].options = _teamData;
            this.formModel = config;
          }, 2000);
        }
      });
    },

    // 递归处理数据
    setTreeData(data) {
      let nodeItem;
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        node.expand = true;
        node.scopedSlots = { title: "custom" };
        node.title = node.dept_name;
        node.value = node.dept_id;
        node.key = node.dept_id;
        if (node.children) {
          if (!node.children.length) {
          } else if (this.setTreeData(node.children)) {
            nodeItem = this.setTreeData(node.children);
          }
        }
      }
      return nodeItem;
    },

    // 递归处理数据 - 团队树处理
    setTreeValueData(data) {
      let nodeItem;
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        node.title = node.dept_name;
        node.key = node.dept_id;
        node.value = node.dept_id;
        if (node.children) {
          if (!node.children.length) {
          } else if (this.setTreeData(node.children)) {
            nodeItem = this.setTreeData(node.children);
          }
        }
      }
      return nodeItem;
    },

    // 点击树节点重新加载
    getLoadKey(e) {
      // console.log(e);
      let [code, level] = e;
      this.level = level || 1;
      this.code = code || "";
      if (this.currentTab == "options") {
        this.getTimesheetList(code);
      } else {
        if (code == "all") {
          return;
        }
        this.getTeamOptionList(code);
        this.getTimesheetTreeList(code, 1);
      }
    },

    // 获取团队工时选项列表
    getTeamOptionList(id) {
      disposeFunc.getTeamOptionList({ team_id: id }).then(res => {
        if (res.status == "success") {
          this.dataSource2 = res.data.list;
          this.selectedKeys = [];
          if (res.data.list && res.data.list.length) {
            res.data.list.forEach(element => {
              this.selectedKeys.push(element.option_code);
            });
          }
        }
      });
    },

    // 过滤数据
    handleTableChange(pagination, filters, sorter) {
      this.filteredInfo = filters;
      this.sortedInfo = sorter;
      if (filters.status && filters.status.length === 0) {
        filters.status = null;
      }
      const code = this.code;
      if (this.currentTab == "options") {
        if (!code) {
          return;
        }
        this.getTimesheetList(code);
      } else {
        this.getTeamOptionList(code);
      }
    },

    //编辑
    editOption(record) {
      this.recordData = record;
      this.params = {
        option_name: record.option_name,
        business_line: record.business_line || "",
        line_of_business: record.line_of_business || "",
        assign_confirm: record.assign_confirm,
        confirm_uid_list:
          record.confirm_list &&
          record.confirm_list.map(item => item.confirm_id),
        last_confirm_uid:
          record.last_confirm && record.last_confirm.last_confirm_id,
        team_list: record.team_list.map(item => {
          return { key: item.team_name, value: item.team_id };
        }),
        status: record.status
      };
      if (record.assign_confirm) {
        this.formModel.elements[4].show = true;
        this.formModel.elements[5].show = true;
      } else {
        this.formModel.elements[4].show = false;
        this.formModel.elements[5].show = false;
      }
      this.visible = true;
      this.operation = "update";
    },

    // 设置使用团队
    setTeam(record) {
      this.recordData = record;
      this.visibleTeam = true;
      this.operation = "update";
    },

    // 刷新
    reload() {
      this.showLoading = true;
      this.params = {};
      this.getOptionsTreeBlock(); // 获取选项树
    },

    // 成本中心
    getBizLineList() {
      disposeFunc
        .bizLineList()
        .then(res => {
          this.bizLineList = res.business_line;
          this.lineOfBusiness = res.line_of_business;
          const config = _.cloneDeep(this.formModel);
          res.business_line.map(item => {
            let obj = {};
            obj.label = item.option_name;
            obj.value = item.option_id;
            config.elements[1].options.push(obj);
          });
          res.line_of_business.map(item => {
            let obj = {};
            obj.label = item.option_name;
            obj.value = item.option_id;
            config.elements[2].options.push(obj);
          });
          this.formModel = config;
        })
        .catch();
    },

    // 获取审批人列表
    getUserList() {
      PriceAdminService.getSimpleUserListFile()
        .then(res => {
          if (res.status == "success") {
            const config = _.cloneDeep(this.formModel);
            res.data.map(item => {
              let obj = {};
              obj.label = item.option_name;
              obj.value = item.option_id;
              config.elements[4].options.push(obj);
              config.elements[5].options.push(obj);
            });
            this.formModel = config;
          }
        })
        .catch();
    },

    // 获取选项的key
    getCheckedKey(key) {
      this.selectedKeys = key;
    }
  }
};
</script>
<style lang="less" scoped>
.dispose-hours {
  margin: 16px;
  min-height: 100vh;
  background-color: #fff;
  &-menu {
    &-item {
      margin-left: 16px;
    }
  }
  &-wrapper {
    display: flex;
    padding: 16px;
    .dispose-hours-left {
      width: 30%;
      min-height: 100px;
      margin-right: 16px;
      border: 1px solid #d9d9d9;
      padding: 16px;
    }
    .dispose-hours-right {
      width: 70%;
      min-width: 70%;
      min-height: 100px;
      border: 1px solid #d9d9d9;
      padding: 16px;
      .top-btn {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        &-right {
          .btn-left {
            margin-right: 8px;
          }
        }
      }
      .dispose-data-table {
        .operation {
          cursor: pointer;
          span {
            font-size: 12px;
            color: #0295ee;
            line-height: 20px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  .dispose-hours-wrapper {
    position: relative;
    .loading-icon {
      width: 100%;
      height: 100vh;
      position: absolute;
      left: 50%;
      top: 200px;
      z-index: 11;
    }
  }
}
</style>
<style lang="less">
.ant-pagination {
  float: right;
  margin-top: 24px;
  margin-bottom: 13px;
}
</style>